import { FieldValues, UseFormRegister } from 'react-hook-form';
import styles from './RadioButton.module.scss';
import classes from 'classnames/bind';
import React from 'react';

const cx = classes.bind(styles);

export interface ICommonProps {
  children: React.ReactNode;
  name: string;
  disabled?: boolean;
  value: string;
}

export interface IControlledProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  register?: never;
}

export interface IUncontrolledProps {
  checked?: never;
  defaultChecked?: never;
  onChange?: never;
  register: UseFormRegister<FieldValues>;
}

export type TRadioButtonProps = ICommonProps & (IControlledProps | IUncontrolledProps);

const RadioButton = ({
  checked,
  children,
  defaultChecked,
  disabled = false,
  name,
  onChange,
  register,
  value,
}: TRadioButtonProps): React.ReactElement => {
  return (
    <label
      className={cx('label', {
        'label-disabled': disabled,
      })}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
        className={cx('radio-button', {
          checked,
        })}
        {...(register && register(name))}
      />
      {children}
    </label>
  );
};

export default RadioButton;
